import { useState, useContext, useEffect, useRef, Fragment } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { Disclosure, Tab } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import Button from "../../components/Button";
import Personal from "./Personal";
import { getCart, saveCart } from "../../utils/localstorage";
import ArrowRightIcon from "@heroicons/react/24/outline/ArrowRightIcon";
import ArrowLeftIcon from "@heroicons/react/24/outline/ArrowLeftIcon";
import { CartContext } from "../../contexts/CartContext";
import { useNavigate } from "react-router-dom";
import Carousel from "../../components/UpdatedCarousel";
import PRODUCTS from "../../../public/assets/products.json";
import VideoModal from "../../components/VideoModal";
import { Dialog } from "@headlessui/react";
import { memberData } from "./MemberData";
// import Professional from "./Professional";
// import ShareAndEarn from "./ShareAndEarn";
import HandSvg from "../../../public/assets/images/hand-pointer.svg";
import PlaySvg from "../../../public/assets/images/play-button.svg";
const categories = ["Details"];

export default function Member() {
  const cartContext = useContext(CartContext);
  const navigate = useNavigate();
  const notify = () => toast("Product is added!");
  const [isOpen, setOpen] = useState(false);

  const [selectedVideoId, setSelectedVideoId] = useState(null);

  const MEMBERSHIP_SKUS = ["B3SubTD", "B3Sub6m", "B3Sub12m"];

  const cart = getCart();
  const [page, setPage] = useState("detail");
  const [prefix, setPrefix] = useState("");
  const [available, setAvailable] = useState("");
  const toastShownRef = useRef(false);

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem("cart"));

    const isMemKitPresent = cart?.some((item) =>
      MEMBERSHIP_SKUS.includes(item.product?.Sku)
    );

    if (isMemKitPresent && !toastShownRef.current) {
      toastShownRef.current = true;
      navigate("/check-out");
      cartContext?.setShowError(true);
    }
  }, []);

  const onClose = () => {
    setOpen(false);
  };

  const addMemKit = (sku) => {
    debugger;
    const existing = cart.find((p) => MEMBERSHIP_SKUS.includes(p.product.Sku));
    if (existing) {
      return;
    }
    const productToAdd = PRODUCTS.find((p) => p.Sku === sku);
    const memberProduct = {
      ...productToAdd,
      Price:
        sku === "B3SubTD" || sku === "B3UmvpTD" ? 0.01 : productToAdd.Price,
    };

    cart.push({ product: memberProduct, qty: 1 });
    notify();
    onClose();
    navigate("/check-out");
    cartContext.save(cart);
  };

  const handleAddToCart = (product) => {
    const existing = cart.find((p) => p.product.Sku === product.Sku);
    if (existing) {
      return;
    } else {
      cart.push({ product: product, qty: 1 });
      notify();
    }
    saveCart(cart);
  };

  const checkAvailability = () => {
    if (prefix.length > 25) {
      return;
    }
    fetch(
      `${process.env.REACT_APP_API_URI}/api/Member/replicatedwebsite/${prefix}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.replicatedNameOnWebSite) {
          setAvailable("Taken");
        } else {
          localStorage.setItem("memberWebsitePrefix", prefix);
          setAvailable("Available");
        }
      });
  };

  return (
    <section className="container mx-auto flex-1 p-5 flex flex-col lg:max-w-full relative">
      {page === "detail" && (
        <>
          {memberData.map(
            ({
              subscriptionDuration,
              details,
              images,
              todayPrice,
              sku,
              videoId,
            }) => {
              return (
                <div className="flex flex-col gap-16 ">
                  <div className="flex flex-col">
                    <div className="block my-auto mb-6 md:mb-auto pt-0 items-center justify-center block lg:hidden mb-4">
                      <Carousel swiperImages={images} />
                      <div className="mt-16">
                        {videoId && (
                          <div className="mt-12 flex justify-center">
                            <Button
                              onClick={() => {
                                setSelectedVideoId(videoId);
                              }}
                              className="flex justify-center bg-[#00adef] hover:bg-[#008bb9] px-3 py-2 text-white shadow-md sm:ml-3 sm:w-auto transform hover:translate-y-1 active:translate-y-0 transition-transform duration-200 text-lg md:text-xl px-2 py-2 rounded-full roboto-regular relative shape w-[160px]"
                              data-mdb-ripple="true"
                              data-mdb-ripple-color="light"
                            >
                              <img
                                src={PlaySvg}
                                alt="Play Icon"
                                width="30"
                                height="30"
                              />
                              <span className="mt-[1px]">Watch Video</span>
                              <img
                                src={HandSvg}
                                alt="Hand Icon"
                                className="ml-2 absolute mt-[28px] ml-[100px] z-10"
                                width="30"
                                height="30"
                              />
                              <div className="custom-div rounded-full"></div>
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="grid-cols-1 items-center flex flex-col-reverse lg:grid lg:grid-cols-2 lg:flex-row flex-1 gap-14">
                      <div className="flex flex-col mb-2 mt-2 md:mt-5 bg-[#302b2b] p-6 rounded-[1rem] h-fit">
                        <h1 className="pb-4 md:pb-0 md:text-5xl text-3xl roboto-medium">
                          <span className="text-white">
                            B<span className="text-[#00adef] mr-2">3</span>U{" "}
                            {subscriptionDuration}
                          </span>
                          <br className="sm:hidden block" />
                        </h1>
                        <div className="hidden md:block w-full px-2">
                          <Tab.Group>
                            <Tab.List className="flex pt-2">
                              {categories.map((category) => (
                                <Tab
                                  key={category}
                                  className={({ selected }) =>
                                    clsx(
                                      "roboto-regular pt-1 xl:text-xl text-[#00adef] font-light leading-5 mr-4 text-lg",
                                      "focus:outline-none border-b-[2px] hover:border-[#00adef]",
                                      selected
                                        ? "border-[#00adef] mr-4"
                                        : "border-transparent"
                                    )
                                  }
                                >
                                  {category}
                                </Tab>
                              ))}
                            </Tab.List>
                            <Tab.Panels className="mt-1">
                              <Tab.Panel key={0}>
                                <Personal details={details} />
                              </Tab.Panel>
                            </Tab.Panels>
                          </Tab.Group>
                        </div>

                        <div className="md:hidden mx-auto w-full rounded-2xl shadow bg-[#302b2b] p-2 px-0">
                          <Disclosure>
                            {({ open }) => (
                              <>
                                <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white px-4 py-2 text-left text-sm font-medium text-blue-900 hover:bg-white focus:outline-none focus-visible:ring focus-visible:ring-white focus-visible:ring-opacity-75">
                                  <span className="text-lg font-bold text-[#00adef]">
                                    Details
                                  </span>
                                  <ChevronUpIcon
                                    className={`${
                                      open ? "rotate-180 transform" : ""
                                    } h-5 w-5 text-blue-500`}
                                  />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                                  <Personal details={details} />
                                </Disclosure.Panel>
                              </>
                            )}
                          </Disclosure>
                        </div>
                        <div className="flex gap-4 py-4 justify-center md:justify-start">
                          <div className="text-2xl md:text-4xl text-[#00adef] my-auto">
                            ${todayPrice} Today
                          </div>
                          <Button
                            onClick={() => addMemKit(sku)}
                            // onClick={() => {
                            //    setOpen(true);
                            // }}
                            className="text-lg md:text-4xl italic px-5 py-2 rounded-full font-normal md:mt-0 roboto-regular-italic"
                            data-mdb-ripple="true"
                            data-mdb-ripple-color="light"
                          >
                            ADD TO CART
                          </Button>
                        </div>
                      </div>
                      <div className="block my-auto mb-6 md:mb-auto hidden lg:block pt-0 items-center justify-center mt-8">
                        <Carousel swiperImages={images} />
                        <div className="mt-16">
                          {videoId && (
                            <div className="mt-12 flex justify-center">
                              <Button
                                onClick={() => {
                                  setSelectedVideoId(videoId);
                                }}
                                className="flex justify-center bg-[#00adef] hover:bg-[#008bb9] px-3 py-2 text-white shadow-md sm:ml-3 sm:w-auto transform hover:translate-y-1 active:translate-y-0 transition-transform duration-200 text-lg md:text-xl px-2 py-2 rounded-full roboto-regular relative shape w-[160px]"
                                data-mdb-ripple="true"
                                data-mdb-ripple-color="light"
                              >
                                <img
                                  src={PlaySvg}
                                  alt="Play Icon"
                                  width="30"
                                  height="30"
                                />
                                <span className="mt-[1px]">Watch Video</span>
                                <img
                                  src={HandSvg}
                                  alt="Hand Icon"
                                  className="ml-2 absolute mt-[28px] ml-[100px] z-10"
                                  width="30"
                                  height="30"
                                />
                                <div className="custom-div rounded-full"></div>
                              </Button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          )}

          {selectedVideoId && (
            <VideoModal
              open={!!selectedVideoId}
              setOpen={() => setSelectedVideoId(null)}
              videoId={selectedVideoId}
            />
          )}

          <div className="w-full flex justify-between mt-10 mb-7 flex-row items-center">
            <NavLink key="b3 bands" to="/nutrition-products">
              <Button className="uppercase text-xs md:text-base px-4 py-1 rounded-full font-light w-auto">
                <div className="inline-block pr-1 relative top-[3px]">
                  <ArrowLeftIcon
                    fill="white"
                    className="h-[0.9rem] md:h-[1.1rem] w-[1.1rem]"
                    aria-hidden="true"
                    color="white"
                  />
                </div>
                {"Back"}
              </Button>
            </NavLink>
            <NavLink key="nutrition products" to="/business-opportunity">
              <Button className="uppercase text-xs md:text-base px-4 py-1 rounded-full font-light w-auto">
                Next
                <div className="inline-block pl-1 relative top-[3px]">
                  <ArrowRightIcon
                    fill="white"
                    className="h-[0.9rem] md:h-[1.1rem] w-[1.1rem]"
                    aria-hidden="true"
                    color="white"
                  />
                </div>
              </Button>
            </NavLink>
          </div>

          <Dialog open={isOpen} onClose={onClose} className="relative z-50">
            <div className="fixed inset-0 bg-black bg-opacity-25" />
            <div className="fixed inset-0 flex items-center justify-center p-4">
              <Dialog.Panel className="max-w-xl w-full rounded bg-white p-6">
                <Dialog.Title></Dialog.Title>
                <Dialog.Description className="mt-2 ">
                  <div className="roboto-regular">
                    <p className="text-lg">
                      If you already have an account with B
                      <span className="text-[#00adef]">3</span> Sciences do not
                      place this order. Simply email us at
                      <a
                        href="mailto:support@b3sciences.com"
                        className="text-[#00adef] ml-1"
                      >
                        support@b3sciences.com
                      </a>{" "}
                      and request your 30 days of free access.
                    </p>
                  </div>
                </Dialog.Description>
                <p className="text-2xl text-center pt-2">
                  Continue with the B<span className="text-[#00adef]">3</span> U
                  Order
                </p>
                <div className="text-center pt-2 flex gap-1">
                  <Button
                    onClick={addMemKit}
                    className="mx-auto !w-full text-base md:text-lg px-5 py-2 rounded-full font-light mt-2 lg:max-w-[300px]"
                    data-mdb-ripple="true"
                    data-mdb-ripple-color="light"
                  >
                    Yes
                  </Button>
                  <Button
                    onClick={onClose}
                    className="mx-auto !w-full text-base md:text-lg px-5 py-2 rounded-full font-light mt-2 lg:max-w-[300px]"
                    data-mdb-ripple="true"
                    data-mdb-ripple-color="light"
                  >
                    No
                  </Button>
                </div>
              </Dialog.Panel>
            </div>
          </Dialog>
        </>
      )}
      {/* {page === "website" && (
        <>
          <SiteSelection
            checkAvailability={checkAvailability}
            onContinue={onContinue}
            setPrefix={setPrefix}
            available={available}
            prefix={prefix}
          />
        </>
      )} */}
    </section>
  );
}
